<template>
  <div
    class="app-container mx-auto my-0 box-border w-full max-w-[1920px] px-4
      transition-[.125s_ease_padding-left] md:px-5 lg:px-10"
  >
    <slot />
  </div>
</template>
